import { render, staticRenderFns } from "./DialogTagManager.vue?vue&type=template&id=2b55d14c&"
import script from "./DialogTagManager.vue?vue&type=script&lang=js&"
export * from "./DialogTagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports